/* istanbul ignore file */
import {
  teamsDarkTheme as fui9TeamsDarkTheme,
  teamsLightTheme as fui9TeamsLightTheme,
} from '@fluentui/react-components';

import type { IPalette, ISemanticColors } from '../colors';
import { TeamsColors, TeamsLegacyColors, YammerColors } from '../colors/teamsPalette';
import { NeutralColors } from '../colors/yammerPalette';

import { createCustomizedThemeWithSlotOverrides } from './createCustomizedThemeWithSlotOverrides';
import { defaultDarkTheme, defaultTheme } from './default';
import type { ITheme } from './theme.types';

// See https://fluentsite.z22.web.core.windows.net/0.54.0/color-schemes
const themeColors: Partial<IPalette> = {
  accent: TeamsColors.brand600, // same as themePrimary
  neutralPrimaryAlt: TeamsColors.gray150,
  themeDarker: YammerColors.brand550,
  themeDark: TeamsColors.brand800,
  themeDarkAlt: TeamsColors.brand800,
  themePrimary: TeamsColors.brand600,
  themeSecondary: fui9TeamsLightTheme.colorBrandForeground2,
  themeTertiary: TeamsColors.brand600,
  themeLight: TeamsColors.brand200,
  themeLighter: YammerColors.brand70,
  themeLighterAlt: YammerColors.brand70,
};

const darkThemeColors: Partial<IPalette> = {
  accent: TeamsColors.brand450,
  neutralDark: TeamsColors.gray50,
  neutralLight: YammerColors.gray860,
  neutralLighter: TeamsColors.gray550,
  neutralLighterAlt: TeamsColors.gray550,
  neutralPrimaryAlt: TeamsColors.gray600,
  neutralQuaternary: TeamsColors.gray750,
  neutralQuaternaryAlt: YammerColors.gray860,
  neutralSecondary: TeamsColors.gray200,
  themeDarker: TeamsColors.brand200,
  themeDark: YammerColors.brand350,
  themeDarkAlt: YammerColors.brand350,
  themePrimary: TeamsColors.brand450,
  themeSecondary: fui9TeamsDarkTheme.colorBrandForeground2,
  themeTertiary: TeamsColors.brand600,
  themeLight: TeamsColors.brand800,
  themeLighter: YammerColors.brand550,
  themeLighterAlt: YammerColors.brand550,
};

const semanticColors: Partial<ISemanticColors> = {
  accentButtonBackground: themeColors.themePrimary,
  bodyBackground: TeamsLegacyColors.gray70,
  bodyFrameBackground: TeamsColors.gray100,
  link: themeColors.themeSecondary,
  linkHovered: themeColors.themePrimary,
  messageLink: themeColors.themeSecondary,
  messageLinkHovered: themeColors.themePrimary,
};

const darkSemanticColors: Partial<ISemanticColors> = {
  accentButtonBackground: darkThemeColors.themePrimary,
  bodyBackground: TeamsLegacyColors.gray870,
  bodyFrameBackground: NeutralColors.gray210,
  bodyStandoutBackground: TeamsColors.gray650,
  link: darkThemeColors.themeSecondary,
  linkHovered: darkThemeColors.themePrimary,
  menuBackground: darkThemeColors.neutralLighter,
  messageLink: darkThemeColors.themeSecondary,
  messageLinkHovered: darkThemeColors.themePrimary,
};

export const teamsTheme: ITheme = createCustomizedThemeWithSlotOverrides({
  name: 'yammerTeams',
  theme: defaultTheme,
  paletteOverrides: themeColors,
  semanticColorOverrides: semanticColors,
});

export const teamsDarkTheme: ITheme = createCustomizedThemeWithSlotOverrides({
  name: 'yammerTeamsDark',
  theme: defaultDarkTheme,
  paletteOverrides: darkThemeColors,
  semanticColorOverrides: darkSemanticColors,
});
